import { cn } from '@/lib/utils';

/**
 * A rising trend adapted from Tabler Icons' MIT-licensed `trending-up` mark.
 * The fixed midnight tile and green signal stay consistent across themes.
 */
export const Logo = ({
  className,
  showWordmark = true,
}: {
  className?: string;
  showWordmark?: boolean;
}) => (
  <span
    className={cn('inline-flex items-center gap-2.5', className)}
    aria-label={showWordmark ? undefined : 'GainSignal'}
  >
    <svg viewBox="0 0 32 32" className="size-7 shrink-0" aria-hidden="true">
      <rect width="32" height="32" rx="8" fill="#0f172a" />
      <g
        transform="translate(4 4)"
        fill="none"
        stroke="#34d399"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 17l6-6 4 4 8-8" />
        <path d="M14 7h7v7" />
      </g>
    </svg>
    {showWordmark ? (
      <span className="text-[15px] font-semibold tracking-[-0.02em] text-ink">
        GainSignal
      </span>
    ) : null}
  </span>
);
